import type { SVGProps } from 'react';
const SvgAutoAwesomeMosaic = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="0.75em"
    height="0.75em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#auto_awesome_mosaic_svg__a)">
      <path
        fill="currentColor"
        d="M3 5v14a2 2 0 0 0 2 2h6V3H5a2 2 0 0 0-2 2Zm16-2h-6v8h8V5c0-1.1-.9-2-2-2Zm-6 18h6c1.1 0 2-.9 2-2v-6h-8v8Z"
      />
    </g>
    <defs>
      <clipPath id="auto_awesome_mosaic_svg__a">
        <path fill="currentColor" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgAutoAwesomeMosaic;
